export default __webpack_public_path__ + "shortlogo.png";